import { EVENT } from "../config";

export const Welcome = () => (
  <section
    id="welcome"
    className="px-6 py-16 md:px-16 md:py-24"
    data-testid="welcome-section"
  >
    <div className="mx-auto max-w-3xl text-center">
      <h2 className="font-display text-3xl font-light tracking-tight text-[#3F3A32] md:text-5xl">
        Welcome
      </h2>
      <div className="mx-auto mt-10 max-w-2xl space-y-6">
        {EVENT.intro.map((para) => (
          <p key={para} className="text-lg font-light leading-relaxed text-[#5E574B] md:text-xl">
            {para}
          </p>
        ))}
      </div>
      <img
        src="/photos/signature.png"
        alt="Pierre Garami"
        data-testid="welcome-signature"
        className="mx-auto mt-12 w-48 md:w-56"
      />
    </div>
  </section>
);
